import { jsx as t, jsxs as l, Fragment as y } from "react/jsx-runtime";
import { memo as C, useState as N, useEffect as k } from "react";
import { Portal as S } from "../Portal/index.js";
import { Skeleton as j } from "antd";
import { useSimpleDrawer as A } from "./hooks.js";
import { R as D } from "../../../CloseOutlined-CEtTmi9p.js";
const T = ({
  width: m = 1600,
  title: f = "",
  children: u,
  footer: p = null,
  className: d = "",
  onCancel: o,
  transform: h = "translateX(-100%)",
  zIndex: a = 2e3,
  opacity: i = 0,
  pointerEvents: w = "none",
  destroyOnHidden: x = !1,
  closeConfirm: b = !1,
  fullWidth: s = !1
}) => {
  const [n, g] = N(!1), r = i === 1;
  if (k(() => {
    const e = setTimeout(() => {
      r && g(!0);
    }, 700);
    return () => clearTimeout(e);
  }, [r]), x && !r)
    return null;
  const c = (e, v) => {
    v === "bg" && (e.stopPropagation(), e.preventDefault(), e.target !== e.currentTarget) || o && (b && !window.confirm("確定要關閉嗎？沒有儲存的內容會遺失") || o());
  };
  return /* @__PURE__ */ t(S, { children: /* @__PURE__ */ l(
    "div",
    {
      style: {
        contain: "strict",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: a,
        pointerEvents: w
      },
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            style: {
              zIndex: a - 1,
              position: "relative",
              width: s ? "100%" : `${m}px`,
              height: "100%",
              maxWidth: s ? "100%" : "max(75%, calc(100% - 100rem))",
              backgroundColor: "#ffffff",
              padding: "2rem 1.5rem 2rem 2rem",
              transform: h,
              transition: "transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
              willChange: "transform"
            },
            className: d,
            children: [
              /* @__PURE__ */ l("div", { className: "at-px-4 at-absolute at-top-4 at-left-0 at-w-full at-h-8 at-flex at-items-center at-justify-between", children: [
                /* @__PURE__ */ t("div", { className: "at-font-semibold at-text-lg at-ml-4", children: f }),
                /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
                  D,
                  {
                    onClick: c,
                    className: "at-text-2xl at-text-gray-700 at-cursor-pointer"
                  }
                ) })
              ] }),
              !n && /* @__PURE__ */ t(j, { active: !0, className: "at-my-8" }),
              n && /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t("div", { className: "at-h-[calc(100%-5rem)] at-mt-12 at-mb-4 at-overflow-auto at-pr-2", children: u }) }),
              /* @__PURE__ */ t("div", { className: "at-px-4 at-absolute at-bottom-2 at-left-0 at-w-full at-h-12 at-flex at-flex-row-reverse at-items-center at-justify-between", children: p })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: "at-absolute at-top-0 at-left-0 at-w-full at-h-full at-bg-black/50",
            style: {
              zIndex: a - 2,
              opacity: i,
              transition: "opacity 0.3s ease-out",
              willChange: "opacity"
            },
            onClick: (e) => c(e, "bg")
          }
        )
      ]
    }
  ) });
}, X = C(T);
export {
  X as SimpleDrawer,
  A as useSimpleDrawer
};
